import React, {Component} from 'react';
import Actions from '../../../actions/Actions.js';
import Remove from './Remove';

class Weight extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.step = window.__discount_object.poundStep(this.props.item.handle);
    this.pound = this.props.item.properties["_pound"];
    //console.log( this.props.item );

  };

  increase = () =>{
    this.pound += this.step;
    let qty = Math.ceil(this.pound/this.step);
    Actions.productUpdate({item:this.props.item,id:this.props.variant_id,quantity:qty});
  };

  decrease = () =>{
    this.pound -= this.step;
    let qty = Math.ceil(this.pound/this.step);
    if( qty<0 ) qty = 0;
    Actions.productUpdate({item:this.props.item,id:this.props.variant_id,quantity:qty});
  };

  render() {
    return (
      <React.Fragment>
        <div className="quantity_container">
          <div className="icon minus" onClick={()=>this.decrease()}>
            -
          </div>
          <div className="text-center">
            <div className="quantity mx-2">{this.pound}</div>
            <div className="unit_name">LBS</div>
          </div>
          <div className="icon plus" onClick={()=>this.increase()}>
            +
          </div>
        </div>
        <Remove
          item={this.props.item}
          variant_id={this.props.variant_id}
          class=""
        />
      </React.Fragment>
    )
  };
}
export default Weight;